module.exports = __webpack_public_path__ + "img/16_65.68b8e892.png";